export const enum ProductSellType {
  PRODUCT_HERO = 'PRODUCT_HERO',
  ACCESSORY = 'ACCESSORY',
}
